import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import {
    ReactiveFormsModule,
    UntypedFormControl,
    UntypedFormGroup,
    Validators,
} from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { RouterModule } from '@angular/router';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { TranslocoModule } from '@jsverse/transloco';
import { NgSelectModule } from '@ng-select/ng-select';

import { HknTypeService, SupplierService } from '@backoffice/costing/domain';
import { type NormCubicMeter } from '@clean-code/models';
import { CanDeactivateForm } from '@clean-code/shared/components/ui-can-deactivate';
import { FormContainerModule } from '@clean-code/shared/components/ui-form-container';
import { NormCubicMeterFormFacade } from '../../application/norm-cubic-meter-form.facade';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'backoffice-frontend-norm-cubic-meter-form',
  templateUrl: './norm-cubic-meter-form.component.html',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslocoModule,
    MatInputModule,
    NgSelectModule,
    FormContainerModule,
    RouterModule,
  ],
})
export class NormCubicMeterFormComponent extends CanDeactivateForm<NormCubicMeter> {
  public navigationUrl = 'settings/norm-cubic-meter';

  public supplierService = inject(SupplierService);
  public hknTypeService = inject(HknTypeService);

  public faTimes = faTimes;

  public suppliers$ = this.supplierService.getAll$();
  public hknTypes$ = this.hknTypeService.search$({});

  formGroup = new UntypedFormGroup({
    id: new UntypedFormControl(),
    year: new UntypedFormControl(null, [Validators.required]),
    factor: new UntypedFormControl(null, [Validators.required]),
    updatedBy: new UntypedFormControl({ value: null, disabled: true }, [
      Validators.required,
    ]),
    updatedDate: new UntypedFormControl({ value: null, disabled: true }, [
      Validators.required,
    ]),
  });

  constructor() {
    const service = inject(NormCubicMeterFormFacade);
    super(service);
  }
}
